import { createReducer, on } from '@ngrx/store';
import * as LoginActions from './login.actions';
import { LoginState } from './login.models';

export const initialState: LoginState = {
  authenticated: undefined,
  loading: undefined,
  error: '',
  currentEmail: '',
};

export const loginReducer = createReducer(
  initialState,
  on(LoginActions.login, (state, { payload }) => ({
    ...state,
    loading: true,
    error: '',
    currentEmail: payload.UserName,
  })),
  on(LoginActions.loginSuccess, (state, { email, response }) => ({
    ...state,
    loading: false,
    error: '',
    authenticated: { [email]: response },
    currentEmail: email,
  })),
  on(LoginActions.loginFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(LoginActions.resetLogin, () => initialState),
  on(LoginActions.logout, () => initialState),
);
